var illustrationConfigs = {};

export function setConfigsLocal(configs) {
    illustrationConfigs = configs;
}

export function getConfigsLocal() {
    return illustrationConfigs;
}
